import CONFIG from "../../config/config";
import { callAuthorizedGraphQLEndpoint } from "../../module/graphQL";

export const getSelfServeCampaignData = async (campaignId) => {
  const gql = `query($campaignId: ID!) {
        selfServeCampaignData(campaignId: $campaignId) {
          selectedCities {
            addresses {
              center
              paths
              editMode
              id
              isVisible
              radius
              type
              value
              isCustomLocationName
              isFixedLocation
              position
              startDate
              endDate
              time
              missionCount
            }
            distributionZones {
              h2h {
                areaType
                center {
                  lat
                  lng
                }
                editMode
                id
                imported
                radius
                type
                value
                paths
              }
              d2d {
                areaType
                center {
                  lat
                  lng
                }
                editMode
                id
                imported
                radius
                type
                value
                paths
              }
            }
            id
            isAddressesPopupOpened
            isVisible
            lat
            lng
            name
            nameWithState
          }
        }
      }`;

  try {
    const request = await callAuthorizedGraphQLEndpoint(
      gql,
      {
        campaignId,
      },
      CONFIG.PATHFINDER_API_BASE_URL
    );

    if (request.status === 200) {
      const {
        data: {
          selfServeCampaignData: { selectedCities },
        },
      } = await request.json();

      return {
        selectedCities,
      };
    }
  } catch (error) {
    return error;
  }
};

export const getEDDMSelfServeCampaignData = async (campaignId) => {
  const gql = `query($campaignId: ID!) {
        eddmSelfServeCampaignData(campaignId: $campaignId) {
          suggestionsEnabled
          distributionLocations {
            isFocused
            lat
            lng
            name
            radius
            selectedRoutes
            suggestedRoutes
          }
          selectedDemographicAttributes {
            label
            value
            options {
              label
              value
              selected
            }
          }
        }
      }`;

  try {
    const request = await callAuthorizedGraphQLEndpoint(
      gql,
      {
        campaignId,
      },
      CONFIG.PATHFINDER_API_BASE_URL
    );

    if (request.status === 200) {
      const {
        data: {
          eddmSelfServeCampaignData: { distributionLocations, selectedDemographicAttributes, suggestionsEnabled },
        },
      } = await request.json();

      return {
        distributionLocations,
        selectedDemographicAttributes,
        suggestionsEnabled,
      };
    }
  } catch (error) {
    return error;
  }
};

export const getAdmCampaignSelfServeData = async (campaignId) => {
  const gql = `query($campaignId: ID!) {
        eddmSelfServeCampaignData(campaignId: $campaignId) {
          campaignDetailedCosts {
            tax
            subtotal
            totalCost
            percentOff
            amountOff
          }
          updateAddressOnMove
        }
      }`;

  try {
    const request = await callAuthorizedGraphQLEndpoint(
      gql,
      {
        campaignId,
      },
      CONFIG.PATHFINDER_API_BASE_URL
    );

    if (request.status === 200) {
      const {
        data: {
          eddmSelfServeCampaignData: { campaignDetailedCosts, updateAddressOnMove },
        },
      } = await request.json();

      return {
        campaignDetailedCosts,
        updateAddressOnMove,
      };
    }
  } catch (error) {
    console.error(error);
    return null;
  }
};
